import { Fragment } from 'react'
import { invitation } from '../data/invitation.js'
import styles from './Invitation.module.css'

export function Invitation() {
  return (
    <div className={styles.wrap}>
      <div className={styles.divider}>
        <span className={`${styles.line} ${styles.lineShort}`} />
        <span className={`${styles.dot} ${styles.dotSmall}`} />
        <span className={`${styles.dot} ${styles.dotMid}`} />
        <span className={`${styles.dot} ${styles.dotSmall}`} />
        <span className={`${styles.line} ${styles.lineShort}`} />
      </div>
      <h2 className={styles.title}>To Our Days</h2>
      <p className={styles.greeting}>
        {invitation.greeting.map((line, i) => (
          <Fragment key={line}>
            {i > 0 && <br />}
            {line}
          </Fragment>
        ))}
      </p>
      <div className={`${styles.divider} ${styles.dividerBottom}`}>
        <span className={`${styles.line} ${styles.lineLong}`} />
        <span className={`${styles.dot} ${styles.dotLarge}`} />
        <span className={`${styles.line} ${styles.lineLong}`} />
      </div>
    </div>
  )
}
